import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function EarningsDisclaimer() {
  return <div className="min-h-screen bg-[#0f1724] text-[#f5f0e8] font-sans selection:bg-[#c9a84c] selection:text-[#0f1724] py-12 px-4 md:px-8" data-id="element-251">
      <div className="max-w-3xl mx-auto" data-id="element-252">
        <Link to="/" className="inline-flex items-center gap-2 text-[#c9a84c] hover:text-[#d4af37] transition-colors mb-8" data-id="element-253">
          <ArrowLeft className="w-4 h-4" data-id="element-254" />
          Back to Home
        </Link>

        <h1 className="font-serif text-3xl md:text-4xl text-white mb-8" data-id="element-255">
          Earnings Disclaimer
        </h1>

        <div className="space-y-6 text-[#f5f0e8]/80 leading-relaxed" data-id="element-256">
          <section className="space-y-3" data-id="element-257">
            <h2 className="text-xl text-white font-bold" data-id="element-258">
              No Guarantee of Results
            </h2>
            <p data-id="element-259">
              The examples used in our marketing materials and in "The Shadow
              Rental Method" blueprint are not a guarantee of the results you
              will achieve. Your results will vary and depend on many factors,
              including but not limited to your background, experience, and work
              ethic. All business entails risk as well as massive and consistent
              effort and action. If you're not willing to accept that, please do
              not purchase this product.
            </p>
          </section>

          <section className="space-y-3" data-id="element-260">
            <h2 className="text-xl text-white font-bold" data-id="element-261">
              Forward-Looking Statements
            </h2>
            <p data-id="element-262">
              Materials in this product and our website may contain information
              that includes or is based upon forward-looking statements within
              the meaning of the securities litigation reform act of 1995.
              Forward-looking statements give our expectations or forecasts of
              future events. You can identify these statements by the fact that
              they do not relate strictly to historical or current facts. They
              use words such as "anticipate," "estimate," "expect," "project,"
              "intend," "plan," "believe," and other words and terms of similar
              meaning in connection with a description of potential earnings or
              financial performance.
            </p>
          </section>

          <section className="space-y-3" data-id="element-263">
            <h2 className="text-xl text-white font-bold" data-id="element-264">Financial Advice</h2>
            <p data-id="element-265">
              We are not financial advisors, and nothing contained in the
              blueprint or on this website should be construed as financial
              advice. You should consult with a qualified professional before
              making any investment decisions. The information provided is for
              educational purposes only.
            </p>
          </section>

          <section className="space-y-3" data-id="element-266">
            <h2 className="text-xl text-white font-bold" data-id="element-267">Testimonials</h2>
            <p data-id="element-268">
              Testimonials, case studies, and examples found on this page are
              results that have been forwarded to us by users of "The Shadow
              Rental Method" products and related products, and may not reflect
              the typical purchaser's experience, may not apply to the average
              person and are not intended to represent or guarantee that anyone
              will achieve the same or similar results.
            </p>
          </section>
        </div>
      </div>
    </div>;
}